import { Directive, ElementRef, inject, OnDestroy, OnInit, output } from '@angular/core';

@Directive({ selector: '[nfClickOutside]' })
export class ClickOutsideDirective implements OnInit, OnDestroy {
  private readonly el = inject(ElementRef);

  readonly clickOutside = output<void>();

  // Uses composedPath() instead of contains() so the check survives Angular's
  // @if-driven DOM mutations that can detach the target node before the handler runs.
  private readonly handler = (event: MouseEvent): void => {
    if (!event.composedPath().includes(this.el.nativeElement)) {
      this.clickOutside.emit();
    }
  };

  ngOnInit(): void {
    document.addEventListener('click', this.handler);
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.handler);
  }
}
